import type { TranslationKeys } from './en'

export const pt: TranslationKeys = {
  schoolSubtitle: 'Acesse pelo aplicativo Agenda1',
  scanQrCode: 'Aponte a câmera do seu celular para o QR Code',
  or: 'ou',
  downloadApp: 'Baixe o aplicativo nas lojas oficiais',
  appStoreBadgeUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/pt-br?size=250x83',
  appStoreBadgeAlt: 'Baixar na App Store',
  playStoreBadgeUrl: 'https://play.google.com/intl/pt-BR/badges/static/images/badges/pt-br_badge_web_generic.png',
  playStoreBadgeAlt: 'Disponível no Google Play',
  openAppStore: 'Abrir na App Store',
  openPlayStore: 'Abrir no Google Play',
  printQrCode: 'Imprimir QR Code',
  schoolCode: 'Código da escola',
  scanInstruction: 'Aponte a câmera do seu celular para o QR Code acima',
  accessUrl: 'ou acesse',
  needHelp: 'Precisa de ajuda? Entre em contato com o suporte',
  support: 'suporte@agenda1.app',
  copyright: `© ${new Date().getFullYear()} Agenda1. Todos os direitos reservados.`,
  // Mobile 2-step flow
  step1Title: 'Baixe o App',
  step1Description: 'Se ainda não tem, baixe o Agenda1',
  step2Title: 'Abra a Escola',
  step2Description: 'Toque para abrir a escola no app',
  openSchoolButton: 'Abrir Escola no App',
  alreadyHaveApp: 'Já tem o app?'
}
